import React from 'react';

const KycVerifiedIcon = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.9974 8.00095L7.33073 9.33428L9.9974 6.66762M13.3307 8.66762C13.3307 12.001 10.9974 13.6676 8.22406 14.6343C8.07884 14.6835 7.92109 14.6811 7.7774 14.6276C4.9974 13.6676 2.66406 12.001 2.66406 8.66762V4.00095C2.66406 3.82414 2.7343 3.65457 2.85932 3.52955C2.98435 3.40452 3.15392 3.33428 3.33073 3.33428C4.66406 3.33428 6.33073 2.53428 7.49073 1.52095C7.63197 1.40028 7.81163 1.33398 7.9974 1.33398C8.18316 1.33398 8.36283 1.40028 8.50406 1.52095C9.67073 2.54095 11.3307 3.33428 12.6641 3.33428C12.8409 3.33428 13.0104 3.40452 13.1355 3.52955C13.2605 3.65457 13.3307 3.82414 13.3307 4.00095V8.66762Z'
        stroke='#00B73F'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default KycVerifiedIcon;
